interface ActionRowProps {
  lifeNumber: number;
  canSubmit: boolean;
  hasStaged: boolean;
  submitting?: boolean;
  canBank?: boolean;
  onRecall: () => void;
  onUndo: () => void;
  onSubmit: () => void;
  onBank?: () => void;
}

export function ActionRow({
  lifeNumber,
  canSubmit,
  hasStaged,
  submitting = false,
  canBank,
  onRecall,
  onUndo,
  onSubmit,
  onBank,
}: ActionRowProps) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onRecall}
        disabled={!hasStaged}
        className="rounded-md border border-stone-300 px-3 py-2 text-sm font-medium text-stone-700 disabled:opacity-40"
      >
        Recall
      </button>
      <button
        type="button"
        onClick={onUndo}
        disabled={!hasStaged}
        className="rounded-md border border-stone-300 px-3 py-2 text-sm font-medium text-stone-700 disabled:opacity-40"
      >
        Undo
      </button>
      {canBank && onBank ? (
        <button
          type="button"
          onClick={onBank}
          className="rounded-md border-b-4 border-amber-700 bg-amber-500 px-3 py-2 text-sm font-bold text-white active:translate-y-px"
        >
          Bank &amp; finish
        </button>
      ) : null}
      <button
        type="button"
        onClick={onSubmit}
        disabled={!canSubmit || submitting}
        className="flex-1 rounded-md bg-emerald-700 px-4 py-2 font-medium text-white disabled:opacity-40"
      >
        {submitting ? 'Submitting…' : `Submit (life ${lifeNumber})`}
      </button>
    </div>
  );
}
